import {Fonts} from "@/constants/font";
import {Keys} from "@/constants/key";
import SpriteUtils from "@/utils/sprite-utils";
import CU from "../utils/c-u";
import {WarriorClass} from "@/store/level/types";
import TextUtils from "@/utils/text-utils";
import {StringUtils} from "@/utils/string-utils";
import {Tr} from "@/i18n/i18n";
import {CreatureUtils} from "@/utils/creature-utils";
import OnceCaller from "@/utils/once-caller";
import {SquareButton} from "@/scenes.ui/square-button";
import {ForceShortDescription} from "@/store/player/types";

export class ListForcesPanel extends Phaser.GameObjects.Container {

    constructor(scene: Phaser.Scene, forceShortDescription:ForceShortDescription[], callback: (wc: WarriorClass) => unknown) {
        super(scene);

        this.scene = scene;
        let excluededForces = [WarriorClass.LIZARD, WarriorClass.TROLL, WarriorClass.ELF, WarriorClass.EMPTY, WarriorClass.NORN,
            WarriorClass.PROVOKATOR,WarriorClass.SORCERER, WarriorClass.ABYSSSOUL, WarriorClass.BABAYAGA, WarriorClass.FACELESS];
        let stepY = 120;
        let padding = 0;

        this.height =  (Object.keys(WarriorClass).length - excluededForces.length) * stepY + padding;

        const back = SpriteUtils.addImage(this.scene, -300, 0, Keys.ATLAS_SHOP_UI, Keys.UI_SHOP_PANEL_BACK).setOrigin(0, 0);
        SpriteUtils.setDispSize(back, CU.CANVAS_WIDTH, this.height+500);
        this.add(back);

        let x = -250;
        let y = stepY/2 + padding;
        for (let warriorClass  in WarriorClass) {
            let wc = warriorClass as WarriorClass;

            if(excluededForces.indexOf(wc) !== -1){
                continue;
            }

            const back = SpriteUtils.addImage(this.scene, x-100,y, Keys.ATLAS_SHOP_UI, Keys.UI_SHOP_PANEL_BACK, 1.3, stepY/180).setOrigin(0, 0.5);
            const separator = SpriteUtils.addSprite(this.scene!, x-100, y+stepY/2, Keys.ATLAS_SHOP_UI, Keys.UI_SHOP_SEPARATOR, 1.1, 1).setOrigin(0, 1);

            const button = SpriteUtils.scale(new SquareButton(this.scene, x+470, y-10, 0, Keys.UI_ART_BROWN_BUTTON,
                undefined, Keys.UI_MANUAL_QUESTION_GREEN, /*Tr('det')*/"", false), 0.65 / CU.S);

            button.setCallback(() => {
                OnceCaller.doOnce("toForceManual", () => {
                    callback(wc);
                }, 300);
            });

            const image = SpriteUtils.addImage(this.scene, x+15, y-10, CreatureUtils.getForceAtlasLarge(wc),
                CreatureUtils.getLargeForceIcon(wc, true),  0.7, 0.7).setOrigin(0.5, 0.5);

            const imageLiner = SpriteUtils.addImage(this.scene, x+15, y, Keys.ATLAS_UI, Keys.UI_BADGE_LINER);

            let forceName = StringUtils.capitalizeFirstLetter(Tr('force').toLowerCase()) + ' ' + StringUtils.capitalizeFirstLetter(CreatureUtils.getClassNameGenetive(wc).toLowerCase())
            let text =  TextUtils.addTextAdvanced(scene, forceName, x + 80, y - 30,
                '#eec761', 20, 'normal', 480, 'left', 2, Fonts.BENGALY_NORMAL);

            let sd = forceShortDescription.find(f => f.warriorClass === wc);
            if (!sd) {
                console.log('wc === ' + wc);
            }
            let shortDesc = sd!.shortDescription || "";
            let desc =  TextUtils.addTextAdvanced(scene, shortDesc, x + 80, y -12,
                '#cbc1b2', shortDesc.length > 65? 13 : 14, 'normal', 340, 'left', 2, Fonts.MYRIADPRO_REGULAR);
            desc.setOrigin(0, 0);

            this.add([back, separator, imageLiner, image, text, desc, button]);
            y += stepY;
        }
    }

}
